// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".results__item[data-v-adba8a7a]{max-width:173px;width:160px;font-size:14px;line-height:18px;overflow:hidden;position:relative}.results__item-title[data-v-adba8a7a]{font-family:\"Poppins-SemiBold\",sans-serif}.results__item-digital-badge[data-v-adba8a7a]{position:absolute;width:40px;right:5px;top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
